import { useLocation } from "react-router-dom";
import { CampasContent } from "../../components/app";

export default function Campas() {
  let location = useLocation();

  return <>{location?.state?.page === "details" ? null : <CampasContent />}</>;
}
